import { SubscriberSimple } from "apps/subscribers/models/subscriber";
import { ActaUser } from "pa_kit/apps/user/models/user";
import { Message } from "./message";
import { Order } from "apps/orders/models/order";

export class Notification {

    constructor(data) {
        this.id = data.id;
        this.subscriber = data.subscriber_data ? new SubscriberSimple(data.subscriber_data) : null;
        this.order_user = data.order_user_data ? new ActaUser(data.order_user_data) : null;
        this.order = new Order(data.order_data);
        this.message = new Message(data.message_data);
        this.description = data.description;
        this.is_read = data.is_read;
        this.created_at = data.created_at;
    }
}